export { default } from './src/insert-anchor';
